export default __webpack_public_path__ + "static/media/LA.8cd4aeb5.svg";